import { Typography, Stack, Box, IconButton, Tooltip } from '@mui/material';
import PropTypes from 'prop-types';
import { Icon as Iconify } from '@iconify/react';
import { useNavigate } from 'react-router-dom';

export default function PostedFilterHeader({ headerName, exportToPDF, exportToExcel, handleOpenFilter, filterValues }) {

    const navigate = useNavigate();

    const downloadPDF = () => {
        exportToPDF();
    };

    const downloadExcel = async () => {
        exportToExcel();
    };

    const openFilter = () => {
        handleOpenFilter()
    }

    const buttons = [
        {
            title: 'Filter',
            icon: 'mdi:filter',
            onClick: openFilter,
            sx: {
                boxShadow: 'inset 0 0 0 #b3b3b3, 0 5px 0 0 #b3b3b3, 0 10px 5px #999999 !important',
                padding: "6px",
                height: "32px",
                width: "35px",
                border: '0.1px solid #e0e0e0',
                margin: '0 -9px 0 16px' // Add margin to reduce padding between buttons
            }
        },
        {
            title: 'Add',
            icon: 'ic:sharp-add',
            size: "small",
            onClick: () => navigate(`${window.location.pathname}add`),
            sx: {
                color: "white",
                bgcolor: '#43b5a2',
                boxShadow: 'inset 0 0 0 #b3b3b3, 0 5px 0 0 #b3b3b3, 0 10px 5px #999999 !important',
                padding: '6px',
                height: "32px",
                width: "35px",
                margin: '0 -9px 0 16px'
            }
        },
        {
            title: 'Export To Excel',
            icon: 'vscode-icons:file-type-excel',
            onClick: downloadExcel,
            sx: {
                bgcolor: '#a6dbbc',
                color: '#fff',
                padding: "6px",
                boxShadow: 'inset 0 0 0 #b3b3b3, 0 5px 0 0 #b3b3b3, 0 10px 5px #999999 !important',
                height: "32px",
                width: "35px",
                margin: '0 -9px 0 16px' // Add margin to reduce padding between buttons
            }
        },
        {
            title: 'Export To PDF',
            icon: 'icomoon-free:file-pdf',
            onClick: downloadPDF,
            sx: {
                bgcolor: '#ED5565',
                color: '#fff',
                boxShadow: 'inset 0 0 0 #b3b3b3, 0 5px 0 0 #b3b3b3, 0 10px 5px #999999 !important',
                padding: "8px",
                height: "32px",
                width: "35px",
                margin: '0 -12px 0 16px' // Add margin to reduce padding between buttons
            }
        }
    ];

    const formatValue = (value) => {
        if (Array.isArray(value)) {
            return value.map(formatValue);
        }
        if (typeof value === 'object' && value !== null) {
            return Object.entries(value)
                .filter(([, val]) => val) // filter out null, undefined, and empty values
                .map(([key, val]) => `${key}: ${formatValue(val)}`);
        }
        return value ? value.toString() : '';
    };

    

    return (
        <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            sx={{ padding: '0px 16px 10px 8px' }}
        >
            {/* Header Title */}
            <Typography variant="h6" sx={{ fontSize: '1rem', lineHeight: '0.9rem' }}>
                {headerName}
            </Typography>

            {/* Buttons */}
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                {buttons.map((button, index) => {
                    let tooltipTitle = button.title;
                    if (button.title === 'Filter' && filterValues && Object.keys(filterValues).length > 0) {
                        tooltipTitle = (
                            <Box sx={{
                                bgcolor: 'white', color: '#000', p: 1, borderRadius: 1,
                                maxWidth: 200,
                                maxHeight: 200,
                                overflowY: 'auto',
                                overflowX: 'hidden',
                            }}>
                                <Stack direction="column" alignItems='flex-start' justifyContent='flex-start' spacing={1}>
                                    {Object.entries(filterValues).map(([key, value]) => (
                                        <Typography variant='body2' key={key}>
                                            <span style={{ fontWeight: 'bold' }}>{key}:</span>
                                            <span style={{ fontSize: '13px' }}>{formatValue(value)}</span>
                                        </Typography>
                                    ))}
                                </Stack>
                            </Box>
                        );
                    }

                    return (
                        <Tooltip key={index} title={tooltipTitle}> { /* NOSONAR: Index as key is acceptable due to non-reordering static list */ }
                            <IconButton
                                onClick={button.onClick}
                                sx={{ ...button.sx, borderRadius: '8px' }}
                            >
                                <Iconify icon={button.icon} />
                            </IconButton>
                        </Tooltip>
                    );
                })}
            </Box>
        </Stack>
    );
}

PostedFilterHeader.propTypes = {
    headerName: PropTypes.any.isRequired,
    exportToPDF: PropTypes.func.isRequired,
    exportToExcel: PropTypes.func.isRequired,
    handleOpenFilter: PropTypes.func.isRequired,
    filterValues: PropTypes.object.isRequired, // Ensure filterValues is an object
};
